const isMockAuth = import.meta.env.VITE_AUTH_MOCK === 'true';

let AuthProvider: React.ComponentType<{ children: React.ReactNode }>;

if (isMockAuth) {
  const { MockAuthProvider } = await import('./MockAuthProvider');
  AuthProvider = MockAuthProvider;
} else {
  const { AuthProvider: RealAuthProvider } = await import('./AuthContext');
  AuthProvider = RealAuthProvider;
}

export { AuthProvider };
export { useAuth } from './useAuthHook';
export { ProtectedRoute } from './ProtectedRoute';
export { LoginPage } from './LoginPage';
